export const initInflight = (callback) => {
    initService(callback);
}

export const initInflightEventListener = (callback) => {
    addEventListener(callback);
}

const initService = (callback) => {
    callTailNumber(callback);
}

const addEventListener = (callback) => {
    callback(true);
}

const callTailNumber = (callback) => {
    let tailNumber = "TCJNH";
    let macId = "3C:8C:F8:FF:A2:65";
    let clientIp = "10.128.244.12";
    let origin = "ICN";
    let destination = "LAX";
    let clientId = "a9dfca65a74d5f1aa3e71d9d7d09625baeb51a94";
    callback(true, macId, clientIp, tailNumber, origin, destination, clientId);
}
